<!-- results-table.component.html -->
<h1 mat-dialog-title><strong>{{action | translate}}</strong> riesgo <span *ngIf="action == 'Delete'"> {{objetivoRiesgo.objetivo.nombre}} / {{objetivoRiesgo.riesgo.nombre}}</span></h1>
<div mat-dialog-content fxLayout="column">
  <div fxFlex *ngIf="action != 'Delete'">
    <mat-form-field class="select-full" fxFlex>
      <mat-label>Objetivo</mat-label>
      <mat-select [(ngModel)]="objetivoRiesgo.objetivo" class="roleSelect"
                  [compareWith]="compareObjects">
          <mat-option *ngFor="let objetivo of objetivos" [value]="objetivo">
              {{objetivo.nombre}}
          </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div fxFlex *ngIf="action != 'Delete'">
    <mat-form-field fxFlex>
      <mat-label>Riesgo</mat-label>
      <input type="text"
             placeholder="Riesgo"
             aria-label="Riesgo"
             matInput
             #riesgoInput
             [formControl]="myControl"
             [matAutocomplete]="auto"
             [(ngModel)]="objetivoRiesgo.riesgo">

            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn.bind(this)">
              <mat-option *ngFor="let riesgo of filteredRiesgos | async" [value]="riesgo">
                {{riesgo.nombre}}
              </mat-option>
              <mat-option (click)="agregarRiesgo()">
                <a>Agregar</a>
              </mat-option>
            </mat-autocomplete>
    </mat-form-field>
  </div>
</div>
<div mat-dialog-actions style="margin-top:50px;">
  <button mat-button (click)="doAction()" #riesgoAcceptInput [disabled]="objetivoRiesgo.riesgo==null || objetivoRiesgo.riesgo.id==null || objetivoRiesgo.objetivo==null">{{action | translate}}</button>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">{{'Cancel' | translate}}</button>
</div>
